<template>
  <!-- 风险提示 -->
  <div class="reminder">
    <el-form class="bginput" style="margin-bottom: 0.8rem;" label-width="8rem">
      <el-form-item label="安全提示数据">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-select v-model="set.getType" placeholder="请选择">
              <el-option label="手动录入" :value="0"></el-option>
              <el-option label="后台获取" :value="1"></el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button @click="add" size="small" type="success">添加数据</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-form v-for="(item,i) of tableData" :key="i" style="margin-bottom: 0.8rem;" class="bginput1" label-width="6rem">
      <el-row :gutter="0">
        <el-col :span="10">
          <el-form-item label="事件主体">
            <el-input v-model="item.subject" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="报警状态">
            <el-select v-model="item.status" placeholder="请选择">
              <el-option label="报警中" :value="1"></el-option>
              <el-option label="已恢复" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <i @click="del(item,i)" class="el-icon-remove-outline" style="font-size: 1rem;line-height: 1.8rem;color: #f00;font-weight: 600;margin-left: 1rem;cursor: pointer;"></i>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="10">
          <el-form-item label="异常类别">
            <el-input v-model="item.alarmCase" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="报警等级">
            <el-select v-model="item.alarmLevel" placeholder="请选择">
              <el-option label="1级" value="1"></el-option>
              <el-option label="2级" value="2"></el-option>
              <el-option label="3级" value="3"></el-option>
              <el-option label="4级" value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="10">
          <el-form-item label="报警时间">
            <el-date-picker v-model="item.alarmTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" type="datetime" placeholder="选择日期时间"> </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="恢复时间">
            <el-date-picker v-model="item.recoverTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" type="datetime" placeholder="选择日期时间"> </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="10">
          <el-form-item label="通知对象">
            <el-input v-model="item.notifyBody" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="通知方式">
            <el-input v-model="item.notifyType" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="10">
          <el-form-item label="处理状态">
            <el-select v-model="item.handleStatus" placeholder="请选择">
              <el-option label="已处理" :value="1"></el-option>
              <el-option label="未处理" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="处理方式">
            <el-input v-model="item.handleType" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="0">
        <el-col :span="10">
          <el-form-item label="发生区域">
            <el-input v-model="item.alarmAddress" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="报警类型">
            <el-select v-model="item.alarmType" placeholder="请选择">
              <el-option label="运行报警" :value="1"></el-option>
              <el-option label="管理报警" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="0">
        <el-col :span="20">
          <el-form-item label="所在位置">
            <el-input style="cursor:pointer;user-select:none;" v-model="item.alarmArea" placeholder="请选择输入或者标注">
              <span @click="Bmap=true;subscript=i" slot="suffix"> <i class="el-input__icon el-icon-location-outline"> </i>地图标注</span>
            </el-input>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="0">
        <el-col :span="20">
          <el-form-item label="事件详情">
            <el-input v-model="item.description" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="20">
          <el-form-item label="建议处理">
            <el-input v-model="item.advise" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="20">
          <el-form-item label="现场视频">
            <el-input v-model="item.liveVideo" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="20">
          <el-form-item label="回放视频">
            <el-input v-model="item.playbackVideo" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>


    </el-form>


    <div style="margin-top: 2rem;">
      <el-button @click="save" size="small" type="primary">保存数据</el-button>
    </div>

    <!--详情-->
    <el-dialog v-dialogDrag title="标注地图" :visible.sync="Bmap" width="60%" :close-on-click-modal='false'>
      <Amap @site='site' @amapDone="amapDone" style="width: 100%;height: 100%;min-height: 32rem;" ref="Amap"></Amap>
      <span slot="footer" class="dialog-footer">
        <span style="position: absolute;left: 0.3rem;">
          {{address}}
        </span>
        <el-button @click="Bmap = false">取 消</el-button>
        <el-button type="primary" @click="Bmap = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/apis/safety/reminder'
import Amap from '@/components/AMap'
export default {
  components: {
    Amap,
  },
  data() {
    return {
      address: '',
      Bmap: false,
      set: {
        getType: 0,
      },
      subscript: 0,
      tableData: [],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    getlist() {
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            if (res.data.list.length) {
              this.tableData = res.data.list
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    add() {
      this.tableData.unshift({
        advise: '', //建议
        alarmAddress: '', //区域
        alarmArea: '', //所在位置
        alarmCase: '', //异常类别
        alarmLevel: '3', //报警等级
        alarmTime: '', //报警时间
        description: '', //事件详情
        handleStatus: 2, //处理状态 1 已处理 2 未处理
        handleType: '', //处理方式
        liveVideo: '', //现场视频
        notifyBody: '', //通知对象
        notifyType: '', //通知方式
        playbackVideo: '', //回放视频
        recoverTime: '', //恢复时间
        status: 1, //1报警中 2已恢复
        subject: '', //事件主题
        alarmType: 1, //报警类型 1运行报警 2 管理报警
        longitude:'',//经度        
        latitude:'',//纬度        
      })
    },
    amapDone() {
      console.log('Amap加载完成.初始化点击选点！')
      this.$nextTick(()=>{
        this.$refs.Amap.setpoint()
      })      
    },
    site(dataArr) {
      let coordinates  = dataArr[0].split(',')
      console.log(dataArr)
      this.tableData[this.subscript].alarmArea = dataArr[1]
      this.address = dataArr[1]
      this.tableData[this.subscript].longitude = coordinates[0]
      this.tableData[this.subscript].latitude = coordinates[1]

    },

    save() {
      api.save(this.tableData).then((res) => {
        if (res.code === 10000) {
          this.getlist()
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    del(item, i) {
      this.$confirm(`确定删除数据？`).then(() => {
        if (item.id) {
          for (const iterator of this.tableData) {
            if (iterator.id === undefined) {
              return this.$message.warning(
                '还有未保存的数据,请先保存后再删除！'
              )
            }
          }
          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
            this.getlist()
          })
        } else {
          this.tableData.splice(i, 1)
        }
      })
    },
  },
}
</script>

<style lang="less">
.reminder { padding-top: 10px;
  .el-form-item{ margin-bottom: 0;}
  .bginput1{ width: 45%; display: inline-block; border: #3570ff solid 1px; padding:1rem; margin-right:1rem;}
}
</style>